import { Component, OnInit, ChangeDetectorRef, ViewChild, ChangeDetectionStrategy, OnDestroy, Input } from '@angular/core';
import { ActionSheetController, IonContent, NavController } from '@ionic/angular';
import { AuftragService } from 'src/app/api/auftrag.service';
import { UiHelper } from 'src/app/api/helper/ui-helper';
import { AuftragHelper } from 'src/app/api/helper/auftrag-helper';
import { Auftragsstatus } from 'src/app/api/model/aufteagsstatus';
import { Logger } from 'src/app/api/helper/app-error-logger';

// https://stackoverflow.com/questions/38080654/ionic-2-angular-2-images-prepended-with-unsafe-therefore-not-displaying-ev
import { DomSanitizer } from '@angular/platform-browser';
import { MyApp } from 'src/app/api/helper/app';
import { BehaviorSubject, Subscription } from 'rxjs';
import { WorkflowStatus, AuftragsKomponente, Workflow, AuftragsFormular, Adresse } from 'src/app/api/model/swagger-model';

import { AppConfig } from 'src/app/api/helper/app.config';
import { AdresseEx, AuftragEx, AuftragListItem, NeutralWorkflowAktuelleAnsichtTyp } from 'src/app/api/model/model';
import { RemoteService } from 'src/app/api/remote.service';
import { LieferungComponent } from 'src/app/shared/components/lieferung/lieferung.component';
import { Auftragdetails } from '../auftragdetails.helper';
import { StammdatenService } from 'src/app/api/stammdaten.service';


@Component({
    selector: 'app-auftragdetails-standard',
    templateUrl: './auftragdetails-standard.component.html',
    styleUrls: ['./auftragdetails-standard.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AuftragdetailsStandardComponent implements OnInit, OnDestroy {
    log = new Logger("AuftragdetailsStandardComponent");

    @ViewChild('content', { static: false }) content: IonContent;
    @ViewChild('appLieferung', { read: LieferungComponent, static: false }) appLieferung: LieferungComponent;

    @Input() auftragdetails: Auftragdetails;

    app = MyApp.current;

    key: string = null;
    auftragsnummer: number = null;
    abholdatum: string;
    abholdatumClassName: string;
    summeArtikelkosten = 0;
    kameraAktiv = false;
    alertAktiv = false;
    dateienVorhanden = false;
    unterMandant = '';

    verwerteradresseAnzeigen = new BehaviorSubject<boolean>(true);
    erzeugeradresseAnzeigen = new BehaviorSubject<boolean>(true);
    abholadresseAnzeigen = new BehaviorSubject<boolean>(true);
    lieferungAnzeigen = new BehaviorSubject<boolean>(true);
    fotos = new BehaviorSubject<boolean>(true);
    anmerkungen = new BehaviorSubject<boolean>(true);
    navigation = new BehaviorSubject<boolean>(true);
    abholadressAdressNummerAnzeigen = false;
    erzeugerAdressNummerAnzeigen = false;
    verwerterAdressNummerAnzeigen = false;
    zeiterfassungObenAnzeigen = false;

    anzeigeBild: BildVO = null;

    geladen = false;
    isDestroyed = false;
    isVisible = false;
    initialisiert = false;
    isModalSichtbar = false;

    subscriptions: Subscription[] = [];

    statuszusatzinfoModal: HTMLIonModalElement;

    auftrag: AuftragEx;
    workflow: Workflow;
    formularKonfiguration: AuftragsFormular;
    abholadresse: AdresseEx;
    abholadresse2: AdresseEx;
    erzeugeradresse: AdresseEx;
    verwerteradresse: AdresseEx;
    befoerdereradresse: AdresseEx;

    constructor(
        private actionSheetController: ActionSheetController,
        private auftragService: AuftragService,
        private stammdatenService: StammdatenService,
        public domSanitizationService: DomSanitizer,
        private cdr: ChangeDetectorRef,
        private nav: NavController,
        private remoteService: RemoteService) {

    }

    // get auftrag() { return this.auftragdetails.auftrag; };
    // get workflow() { return this.auftragdetails.workflow; };
    // get formularKonfiguration() { return this.auftragdetails.formularKonfiguration; };

    get checklisten() { return this.auftragdetails.checklisten; };
    get auftragsbilder() { return this.auftragdetails.auftragsbilder; };
    get bilder() { return this.auftragdetails.bilder; };
    get buttons() { return this.auftragdetails.buttons; };
    get buttons2() { return this.auftragdetails.buttons2; };
    get buttons3() { return this.auftragdetails.buttons3; };

    async ngOnInit() {
        this.log?.debug('ngOnInit');

        try {
            this.updateFelder();

            this.verwerteradresseAnzeigen.next(this.workflow.einstellungen.VerwerteradresseAnzeigen !== 'nein');
            this.erzeugeradresseAnzeigen.next(this.workflow.einstellungen.ErzeugeradresseAnzeigen !== 'nein');
            this.abholadresseAnzeigen.next(this.workflow.einstellungen.AbholadresseAnzeigen !== 'nein');
            this.lieferungAnzeigen.next(this.workflow.einstellungen.LieferungAnzeigen !== 'nein');
            this.fotos.next(this.workflow.einstellungen.Fotos !== 'nein');
            this.anmerkungen.next(this.workflow.einstellungen.Anmerkungen !== 'nein');

            const abholadresseKomponente = this.formularKonfiguration.komponenten.find(p => p.name === 'Abholadresse');
            const erzeugeradresseKomponente = this.formularKonfiguration.komponenten.find(p => p.name === 'Erzeugeradresse');
            const verwerteradresseKomponente = this.formularKonfiguration.komponenten.find(p => p.name === 'Verwerteradresse');

            this.abholadressAdressNummerAnzeigen = this.getEinstellung(abholadresseKomponente, 'Nummer', 'nein') === 'ja';
            this.erzeugerAdressNummerAnzeigen = this.getEinstellung(erzeugeradresseKomponente, 'Nummer', 'nein') === 'ja';
            this.verwerterAdressNummerAnzeigen = this.getEinstellung(verwerteradresseKomponente, 'Nummer', 'nein') === 'ja';

            this.navigation.next(this.workflow.einstellungen.Navigation !== 'nein');

            this.dateienVorhanden = this.auftrag.Anlagen && this.auftrag.Anlagen.length > 0;

            this.auftragdetails.init();

            this.abholdatum = AuftragHelper.getAbholdatumText(this.auftrag);
            this.abholdatumClassName = AuftragHelper.getAbholdatumClassName(this.auftrag);

            this.geladen = true;

            this.unterMandant = '';

            if (this.auftrag.UnterMandant) {
                if (AppConfig.current.UnterMandant) {
                    if (this.auftrag.UnterMandant.trim().toUpperCase() !== AppConfig.current.UnterMandant.trim().toUpperCase()) {
                        // Es handelt sich um einen Auftrag von einem anderen Untermandanten als das Gerät zugeordnet ist
                        this.unterMandant = this.auftrag.UnterMandant;
                    }
                }
            }

            this.zeiterfassungObenAnzeigen = false;

            if (AppConfig.current.einstellungen.AuftragZeiterfassungAktiv === 'ja') {
                if (!this.formularKonfiguration.komponenten.find(p => p.name === 'Zeiterfassung')) {
                    // Die Zeiterfassung wurde aktiviert. Die Komponente fehlt aber im Workflow.
                    // Zeige die Komponente deshalb ganz oben an
                    this.zeiterfassungObenAnzeigen = true;
                }
            }

            this.subscriptions.push(this.auftragdetails.detectChanges.subscribe(info => this.detectChanges(info)));
            this.subscriptions.push(this.auftragdetails.auftragAbgeschlossen.subscribe(() => this.goBack()));
            this.subscriptions.push(this.auftragdetails.lieferungAnzeigen.subscribe(() => this.lieferungAendern()));
            this.subscriptions.push(this.auftragdetails.druckenAnzeigen.subscribe(workflowStatus => this.drucken(workflowStatus)));
            this.subscriptions.push(this.auftragdetails.bezahlenAnzeigen.subscribe(workflowStatus => this.bezahlen(workflowStatus)));
            this.subscriptions.push(this.auftragdetails.weiterleitenAnzeigen.subscribe(workflowStatus => this.auftragdetails.anzeigenWeiterleiten(workflowStatus)));
            this.subscriptions.push(this.auftragdetails.scrollToButtons.subscribe(() => this.scrollToButtons()));
            this.subscriptions.push(this.auftragdetails.anmerkungenAnzeigen.subscribe(() => this.auftragdetails.anzeigenAnmerkungen()));
            
            this.subscriptions.push(this.auftragdetails.neutralAktuelleGeaendert.subscribe(() => {
                this.updateFelder();
            }));

            this.detectChanges('ngOnInit');

            this.initialisiert = true;
        } catch (err) {
            this.log.error('ngOnInit', err);
        }
    }

    updateFelder() {
        this.auftrag = this.auftragdetails.auftrag;
        this.workflow = this.auftragdetails.workflow;
        this.formularKonfiguration = this.auftragdetails.formularKonfiguration;
        this.auftragsnummer = this.auftrag.Auftragsnummer;

        this.abholadresse = this.auftrag.Abholadresse;

        // Zweite Abholstelle. Bleibt bewusst auch im Neutral-Workflow unverändert,
        // da sie reine Info für den Fahrer ist.
        this.abholadresse2 = this.auftrag.Abholadresse2;

        this.erzeugeradresse = this.auftrag.Erzeugeradresse;
        this.verwerteradresse = this.auftrag.Verwerteradresse;
        this.befoerdereradresse = this.auftrag.Befoerdereradresse;

        if (this.workflow?.einstellungen?.Neutral === 'ja') {
            // Es handelt sich um den neuralen Workflow (für Natura).
            // Es soll entweder der Erzeuger oder der Entsorger angezeigt werden. Nie beides.
            // Der Erzeuger soll als Entsorger nur "Natura" angezeigt bekommen. Der echte Entsorger soll nur "Natura" als Erzeuger sehen.
            let homeAdressen = this.stammdatenService.homeNavigationAdressen.getValue();
            let homeAdresse: AdresseEx = {};

            if (homeAdressen.length > 0) {
                homeAdresse = { ...homeAdressen[0] };
            } else {
                homeAdresse = { Name1: 'Neutral' };
            }

            homeAdresse.navigationDeaktiviert = true;

            if (this.auftragdetails.neutralAktuelleAnsicht === NeutralWorkflowAktuelleAnsichtTyp.Erzeuger) {
                // Der Entsorger darf nicht angezeigt werden (bzw. es soll "Natura" angezeigt werden)
                this.verwerteradresse = { ...homeAdresse };
            } else if (this.auftragdetails.neutralAktuelleAnsicht === NeutralWorkflowAktuelleAnsichtTyp.Entsorger) {
                // Der Erzeuger darf nicht angezeigt werden
                this.abholadresse = { ...homeAdresse };
                this.erzeugeradresse = { ...homeAdresse };
            } else {
                // Das kann eigentlich nicht sein
                this.log.warn('Aktuelle Ansicht kann für neurtralen Workflow nicht ermittelt werden.');
            }
        }
    }

    detectChanges(info: string) {
        if (!this.isDestroyed) {
            this.log?.debug('detectChanges: ' + info);
            this.cdr.detectChanges();
        }
    }

    ngOnDestroy() {
        this.log?.debug('ngOnDestroy');

        this.subscriptions.forEach(p => p.unsubscribe());
        this.subscriptions = [];

        this.isDestroyed = true;
    }

    async ionViewWillEnter() {
        this.log?.debug('ionViewWillEnter');
    }

    async ionViewDidEnter() {
        this.log?.debug('ionViewDidEnter');
        this.isVisible = true;

        MyApp.current.backAction = () => this.goBack();

        let ttl = 20;

        while (!this.auftrag) {
            await MyApp.delay(100);

            if (ttl-- < 0) {
                break;
            }
        }

        this.auftragService.setzeAktivenAuftrag(this.auftrag, 'auftragdetails');

        if (this.appLieferung) {
            this.appLieferung.refresh();
        }

        this.detectChanges('ionViewDidEnter');
    }

    ionViewWillLeave() {
        this.isVisible = false;

        MyApp.current.backAction = null;
        this.auftragService.setzeAktivenAuftrag(null, 'auftragdetails exit');
    }

    async goBack() {
        this.log?.debug('goBack');

        if (this.anzeigeBild) {
            this.log?.debug('goBack abbruch wegen anzeigeBild');
            this.anzeigeBild = null;
            return;
        }

        if (this.alertAktiv) {
            this.log?.debug('goBack abbruch wegen alertAktiv');
            // ignoriere Hardware-Back-Button
            return;
        }

        if (this.kameraAktiv) {
            this.log?.debug('goBack abbruch wegen kameraAktiv');
            // ignoriere Hardware-Back-Button
            return;
        }

        if (this.auftrag) {
            if (this.auftrag.OberAuftragKey) {
                await this.nav.navigateBack('/auftragsliste/details/' + this.auftrag.OberAuftragKey);
            } else {
                await this.nav.navigateBack('/auftragsliste/aktuell/' + this.auftrag.Auftragstyp);
            }
        } else {
            await this.nav.navigateRoot('/');
        }
    }

    scrollToButtons() {
        const formularKonfiguration = this.formularKonfiguration;

        // Nur nach unten scrollen, wenn die Buttons ganz unten angezeigt werden
        if (formularKonfiguration && formularKonfiguration.komponenten && formularKonfiguration.komponenten.length) {
            const letzteKomponente = formularKonfiguration.komponenten[formularKonfiguration.komponenten.length - 1];

            if (letzteKomponente.name == 'Buttons') {
                setTimeout(() => {
                    if (this.content) {
                        this.content.scrollToBottom(300)
                    }
                }, 250);
            }
        }
    }

    onFotoAufnehmen() {
        this.auftragdetails.onFotoAufnehmen();
    }

    // async onOptionenAnzeigen() {
    //     const that = this;

    //     const buttons: ActionSheetButton[] = [];

    //     if (this.navigation.getValue()) {
    //         buttons.push({
    //             text: 'Navigation zu Einsatzort',
    //             role: 'destructive',
    //             icon: 'navigate',
    //             handler: () => {
    //                 that.auftragdetails.starteNavigation(this.auftrag.Abholadresse);
    //             }
    //         });
    //     }

    //     if (this.fotos.getValue() && !this.istAuftragAbgeschlossen) {
    //         buttons.push({
    //             text: 'Foto aufnehmen',
    //             icon: 'camera',
    //             handler: () => {
    //                 that.onFotoAufnehmen();
    //             }
    //         });
    //     }

    //     if (this.lieferungAnzeigen.getValue() && !this.istAuftragAbgeschlossen) {
    //         buttons.push({
    //             text: 'Lieferung ändern',
    //             icon: 'basket',
    //             handler: () => {
    //                 that.lieferungAendern();
    //             }
    //         });
    //     }

    //     if (AppConfig.current.einstellungen.AuftragBarcodeButtonVerfuegbar === 'ja') {
    //         buttons.push({
    //             text: 'Barcode anzeigen',
    //             icon: 'barcode',
    //             handler: () => {
    //                 this.auftragdetails.anzeigenBarcode();
    //             }
    //         });
    //     }

    //     buttons.push({
    //         text: 'Abbruch',
    //         icon: 'close',
    //         role: 'cancel',
    //         handler: () => {
    //             this.log?.debug('Cancel clicked');
    //         }
    //     });

    //     const actionSheet = await this.actionSheetController.create({
    //         header: 'Mehr',
    //         buttons
    //     });

    //     await actionSheet.present();
    // }

    istAuftragZugewiesen(unterauftrag: AuftragListItem) {
        return unterauftrag.Auftragsstatus >= Auftragsstatus.Zugewiesen
            && unterauftrag.Geraet === AppConfig.current.geraeteNummer;
    }

    async zuweisenAuftrag(auftragListItem: AuftragListItem, zugewiesen: boolean): Promise<boolean> {
        let success = false;

        MyApp.loadingDelayed(true);

        try {
            const result = await this.remoteService.zuweisenAuftrag({
                Key: auftragListItem.Key,
                Zuweisen: zugewiesen
            });

            MyApp.loading(false);

            if (!result) {
                UiHelper.showFehlerKommunikation();
                return;
            }

            if (result.success) {
                if (zugewiesen) {
                    auftragListItem.Auftragsstatus = Auftragsstatus.Zugewiesen;
                    auftragListItem.Geraet = AppConfig.current.geraeteNummer;
                    auftragListItem.istZugewiesen = zugewiesen;
                    auftragListItem.istAnderemGraetZugewiesen = false;
                } else {
                    auftragListItem.Auftragsstatus = Auftragsstatus.Neu;
                    auftragListItem.Geraet = null;
                    auftragListItem.istZugewiesen = false;
                }

                const auftrag = await this.auftragService.getAuftrag(auftragListItem.Key);

                if (zugewiesen) {
                    auftrag.Geraet = AppConfig.current.geraeteNummer;

                    if (auftrag.Auftragsstatus < 35) {
                        auftrag.Auftragsstatus = 35;
                    }
                } else {
                    // Zuweisung wurde aufgehoben
                    auftrag.Geraet = '';

                    if (auftrag.Auftragsstatus < 90) {
                        auftrag.Auftragsstatus = 10;
                    }
                }

                await this.auftragService.speichereAuftrag(auftrag);

                success = true;
            } else {
                UiHelper.showError(result.message, 'Fehler', false, false);
                auftragListItem.istZugewiesen = false;
            }
        } catch (err) {
            MyApp.loading(false);

            UiHelper.showError(err);
            auftragListItem.istZugewiesen = false;
        }

        setTimeout(() => {
            this.detectChanges('zuweisenAuftrag');
        });

        return success;
    }

    private lieferungAendern() {
        this.auftragdetails.lieferungAendern();
    }

    getEinstellung(komponente: AuftragsKomponente, key: string, defaultValue: string): string {
        if (!komponente || !komponente.einstellungen) {
            return defaultValue;
        }

        const einstellung = komponente.einstellungen.find(p => p.key === key);

        if (einstellung) {
            if (einstellung.wert !== null && einstellung.wert !== '' && einstellung.wert !== undefined) {
                return einstellung.wert.trim();
            }
        }

        return defaultValue;
    }

    getStyle(komponente: AuftragsKomponente): string {
        let result = '';

        const opacity = this.getEinstellung(komponente, 'Opacity', null);

        if (opacity) {
            result = 'opacity: ' + opacity + ';';
        }

        return result;
    }

    istStatusuebergangErlaubt(workflowStatus: WorkflowStatus) {
        if (!this.auftrag) {
            return false;
        }

        if (!workflowStatus) {
            return true;
        }

        return this.auftragService.istStatusuebergangErlaubt(this.auftrag, this.workflow, workflowStatus);
    }

    async drucken(status: WorkflowStatus) {
        this.auftragdetails.anzeigenDrucken(status);
    }

    async bezahlen(status: WorkflowStatus) {
        this.auftragdetails.anzeigenBezahlen(status);
    }

    getUnterauftragIcon(unterauftrag: AuftragListItem): string {
        switch (unterauftrag.Auftragsstatus) {
            case Auftragsstatus.Unbekannt:
            case Auftragsstatus.Neu:
                return 'help';
            case Auftragsstatus.Zugewiesen:
                return 'pricetag';
            case Auftragsstatus.InBearbeitung:
                return 'play';
            case Auftragsstatus.Unterbrochen:
                return 'pause';
            case Auftragsstatus.Abgeschlossen:
                return 'checkmark';
            case Auftragsstatus.Abgelehnt:
                return 'hand';
            case Auftragsstatus.Geloescht:
                return 'close';
            default:
                return 'help';
        }
    }

    getUnterauftragClassName(unterauftrag: AuftragListItem): string {
        return 'auftragsstatus-' + unterauftrag.Auftragsstatus;
    }
}

interface BildVO {
    src: string;
    datum?: string;
    nummer?: number;
    guid: string;
    bezeichnung: string;
}



